<template>
  <div class="information">
    <el-form class="custom-formScreen" ref="formScreen" :model="formScreen" label-width="4.8vw" inline>
      <el-form-item label="分公司" prop="branchCompanyId">
        <el-select v-model="formScreen.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
          <el-option
              v-for="item in listBranch"
              :key="item.id"
              :label="item.companyFullName"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子公司" prop="companyId">
        <el-select v-model="formScreen.companyId" filterable placeholder="请选择">
          <el-option
              v-for="item in listSon"
              :key="item.id"
              :label="item.companyFullName"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
            v-model="formScreen.startTime"
            align="right"
            type="date"
            placeholder="选择开始日期"
            format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
            v-model="formScreen.endTime"
            align="right"
            type="date"
            placeholder="选择结束日期"
            format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label=" " prop="searchString" style="width: 100%;">
        <el-input v-model.trim="formScreen.searchString" placeholder="全字段搜索" style="width: 400px;"></el-input>
        <el-input v-model.trim="formScreen.internalConveyNumber" placeholder="国内单号" style="width: 300px;margin-left:15px;"></el-input>
        <el-input v-model.trim="formScreen.conveyNumber" placeholder="国际单号" style="width: 300px;margin-left:15px;"></el-input>
        <el-input
					v-model.trim="formScreen.searchStrings"
					placeholder="多个订单号/国际运单号/国内运单号，以空格分开"
					style="width: calc(100% - 800px); margin-top: 20px"
				></el-input>
        <el-button type="primary" @click="searchForm" style="margin-left: 10px;">搜索</el-button>
        <el-button type="primary" @click="resetForm('formScreen')">重置</el-button>
      </el-form-item>

    </el-form>
    <el-table :data="listTable" border style="width: 100%" :header-cell-style="{ textAlign: 'center' }" v-loading="loadingTable">
      <el-table-column prop="id" width="100" label="主键" align="center"></el-table-column>
      <el-table-column label="产品信息" width="300" align="left">
        <template slot-scope="scope">
          <el-row type="flex" v-for="item in scope.row.orderItems" :key="item.id">
            <el-popover trigger="hover" placement="right">
              <img :src="item.imageUrl" class="prduct_img" alt/>
              <div class="scope_img" slot="reference">
                <img :src="item.imageUrl" alt/>
              </div>
            </el-popover>
            <div style="margin-left: 10px;">
                <div>price: {{ item.itemAmount + item.itemCurrencyCode }}</div>
                <div>SKU：{{ item.sellerSKU }}</div>
            </div>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column prop="orderId" width="240" label="订单号" align="left">
        <template slot-scope="scope">
          <div>订单号：{{ scope.row.amazonOrderId }}</div>
          <div>订单ID：{{ scope.row.orderId }}</div>
          <el-row style="display: flex;align-items: center;">
              <el-tag v-if="scope.row.outInterceptStatus === 1" type="danger" effect="dark" size="mini">拦截</el-tag>
              <el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom" v-if="scope.row.isFreeze === 1">
                <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
              </el-tooltip>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column width="240" label="国内单号" align="center">
        <template slot-scope="scope">
          <div v-for="item in scope.row.purchases" :key="item.id">
            <div>{{ item.internalConveyNumber }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="waybillInternationalNumber" width="240" label="国际单号" align="center">
        <template slot-scope="scope">
          <el-row type="flex" justify="center" align="middle" v-for="(item,index) in scope.row.orderChannels"
                  :key="index">
            <div style="cursor: pointer;" @click="queryExternalcall(item)">
              <span :id="item.conveyNumber"
                    :style="{ color: item.isActive ? '#51c4d3' : '' }">{{ item.conveyNumber + '：' }}</span>
            </div>
            <!--                        <span v-if="item.status == 0" style="color:blue;">未处理</span>-->
            <!--                        <span v-else-if="item.status == 1" style="color:red;">作废</span>-->
            <!--                        <span v-else-if="item.status == 2" style="color:blue;">未发货</span>-->
            <!--                        <span v-else-if="item.status == 3" style="color:blue;">未发货</span>-->
            <!--                        <span v-else-if="item.status == 4" style="color:green;">已发货</span>-->
            <span :style="{color: internationalOrderStatus[item.status].color}">
                          {{ internationalOrderStatus[item.status].title }}
                      </span>
          </el-row>
          <!-- <div v-html="scope.row.waybillInternationalNumber"></div> -->
          <!-- <div v-for="(item,index) in scope.row.orderChannels" :key="index">
                  {{ item.conveyNumber }}:
                  <span style="color:blue;" v-if="item.status === 0">未发货</span>
                  <span style="color:red;" v-else-if="item.status === 1">作废</span>
                  <span style="color:green;" v-else-if="item.status === 2">已发货</span>
                  <span style="color:blue;" v-else-if="item.status === 3">未发货</span>
                  <span style="color:green;" v-else-if="item.status === 4">已发货</span>
              </div> -->
        </template>
      </el-table-column>
      <el-table-column prop="purchaseResultTime" width="200" label="入库时间" align="center"></el-table-column>
      <el-table-column prop="inventoryTime" width="200" label="出库时间" align="center"></el-table-column>
      <el-table-column width="200" label="出入库时间差" align="center">
        <template slot-scope="scope">
          <div>{{ timeDifference(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" width="200" label="更新时间" align="center"></el-table-column>
      <!-- <el-table-column prop="branchCompanyName" label="所属分公司" width="200" align="center"></el-table-column>
      <el-table-column prop="subCompanyName" label="所属子公司" width="200" align="center"></el-table-column> -->
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="190" align="center">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" @click="edit(scope.row)">轨迹</el-button>
            <el-button type="warning" @click="checkReduction(scope.row)" :disabled="scope.row.infoCheckStatus == 0" v-if="str.rid == '1'">审核还原</el-button>
          </div>
          <div style="margin-top:5px;">
            <el-button type="warning" @click="reduction(scope.row)" :disabled="scope.row.buttonStatus == 1" v-if="str.rid == '1'">还原</el-button>
            <el-button type="warning" @click="cancelIntercept(scope.row)" :disabled="scope.row.outInterceptStatus == 0" v-if="str.rid == '1'">取消拦截</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </el-row>
    <el-dialog title="仓库轨迹" :visible.sync="dialogVisible" width="30%">
      <el-timeline :reverse="true">
        <el-timeline-item
            v-for="activity in Warehousetrack"
            :key="activity.id"
            :timestamp="activity.createTime"
        >
          <div>{{ activity.operateName }}</div>
          <div>{{ activity.roleName }}</div>
        </el-timeline-item>
      </el-timeline>

      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 认</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import { Baseurl, ajaxPost } from "../../api/api/api";

export default {
  name: "Circulationmanagement",
  data() {
    return {
      str:"",
      headClass: this.common.headClass,
      dialogVisible: false,
      page: 1,
      size: 20,
      total: 0,
      listTable: [],
      formScreen: {
        startTime: "",
        endTime: "",
        searchString: "",
        searchStrings: '',
        branchCompanyId: "",
        companyId: "",
        internalConveyNumber:"",
        conveyNumber:"",
      },
      Warehousetrack: [],
      listBranch: [],
      listSon: [],
      loadingTable: false,
      internationalOrderStatus: Object.freeze({
        0: { title: "未发货", color: 'blue' },
        1: { title: "作废", color: 'red' },
        2: { title: "未发货", color: 'blue' },
        3: { title: "未发货", color: 'blue' },
        4: { title: "已发货", color: 'green' },
        5: { title: "已签收", color: '#cc163a' },
        6: { title: "在途", color: '#feba07' },
        7: { title: "揽收", color: '#f97d1c' },
        8: { title: "疑难", color: '#ffa60f' },
        9: { title: "退签", color: '#de1c31' },
        10: { title: "派件", color: '#b7511d' },
        11: { title: "退回", color: '#ec4e8a' },
        12: { title: "转投", color: '#f09c5a' },
        13: { title: "待清关", color: '#619ac3' },
        14: { title: "清关中", color: '#2775b6' },
        15: { title: "已清关", color: '#22a2c3' },
        16: { title: "清关异常", color: '#ef498b' },
        17: { title: "拒签", color: '#c21f30' },
        18: { title: '清关', color: '#c21f30' },
				101: { title: '已下单', color: '#c21f30' },
				102: { title: '待揽收', color: '#c21f30' },
				103: { title: '已揽收', color: '#c21f30' },
				1001: { title: '到达派件城市', color: '#c21f30' },
				1002: { title: '干线', color: '#c21f30' },
				1003: { title: '转递', color: '#c21f30' },
				501: { title: '投柜或驿站', color: '#c21f30' },
				301: { title: '本人签收', color: '#c21f30' },
				302: { title: '派件异常后签收', color: '#c21f30' },
				303: { title: '代签', color: '#c21f30' },
				304: { title: '投柜或站签收', color: '#c21f30' },
				401: { title: '已销单', color: '#c21f30' },
				201: { title: '超时未签收', color: '#c21f30' },
				202: { title: '超时未更新', color: '#c21f30' },
				203: { title: '拒收', color: '#c21f30' },
				204: { title: '派件异常', color: '#c21f30' },
				205: { title: '柜或驿站超时未取', color: '#c21f30' },
				206: { title: '无法联系', color: '#c21f30' },
				207: { title: '超区', color: '#c21f30' },
				208: { title: '滞留', color: '#c21f30' },
				209: { title: '破损', color: '#c21f30' },
				210: { title: '销单', color: '#c21f30' },
      }),
    };
  },
  created() {
    this.str = JSON.parse(localStorage.getItem("role"));
    this.getTableList();
    this.getBranchCompanyList();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    edit(row) {
      const API = Baseurl + "logisticsController/getOrderOperateLog";
      const paramsData = {
        orderId: row.orderId,
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.Warehousetrack = data;
          this.dialogVisible = true;
        }
      });
    },
    searchForm() {
      this.page = 1
      this.getTableList()
    },
    resetForm(formName) {
      this.page = 1
      this.$refs[formName].resetFields();
      this.listSon = [];
      this.formScreen.internalConveyNumber = ""
      this.formScreen.conveyNumber = ""
      this.formScreen.searchStrings = ""
      this.getTableList();
    },
    handleSizeChange(val) {
      this.size = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTableList();
    },
    getTableList() {
      const API = Baseurl + "logisticsController/getCirculationManageList";
      const paramsData = {
        page: this.page,
        size: this.size,
        ...this.formScreen,
      };
      if (this.formScreen.searchStrings) {
				this.$set(paramsData, 'searchStrList', this.formScreen.searchStrings.split(' '))
			} else {
				this.$set(paramsData, 'searchStrList', [])
			}
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data;
        if (code === 200) {
          this.listTable = data.list;
          this.total = data.total;
        }
      });
    },
    timeDifference(item) {
      if (!item.purchaseResultTime) return;
      if (!item.inventoryTime) return;
      const startTime = item.purchaseResultTime.replace(/-/g, "/");
      const endTime = item.inventoryTime.replace(/-/g, "/");
      const startTimeStamp = new Date(startTime);
      const endTimeStamp = new Date(endTime);
      const timeStamp = Number(endTimeStamp) - Number(startTimeStamp);
      const day = Math.floor(timeStamp / (24 * 3600 * 1000));
      const leave1 = timeStamp % (24 * 3600 * 1000);
      const h = Math.floor(leave1 / (3600 * 1000));
      const leave2 = leave1 % (3600 * 1000);
      const m = Math.floor(leave2 / (60 * 1000));
      const leave3 = leave2 % (60 * 1000);
      const s = Math.round(leave3 / 1000);
      return `${ day }天${ h }时${ m }分${ s }秒`;
    },
    selectChange(id) {
      this.getSonCompanyList(id);
    },
    getBranchCompanyList() {
      const API = Baseurl + "logisticsController/getAllBranchCompany";
      ajaxPost(API).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listBranch = data;
        }
      });
    },
    getSonCompanyList(id) {
      const API = Baseurl + "logisticsController/getAllSubCompanyById";
      const paramsData = { id };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listSon = data;
        }
      });
    },
    queryExternalcall(item) {
      this.listTable.forEach(item => {
        if (!Array.isArray(item.orderChannels)) return
        item.orderChannels.forEach(key => {
          this.$set(key, 'isActive', false)
          // key.isActive = false
        })
      })
      item.isActive = true
      window.YQV5.trackSingleF1({
        //必须，指定悬浮位置的元素ID。
        YQ_ElementId: item.conveyNumber,
        //可选，指定查询结果宽度，最小为260px，默认为470px。
        YQ_Width: 500,
        //可选，指定查询结果高度，最大为800px，默认为560px。
        YQ_Height: 600,
        //可选，指定运输商，默认为自动识别。
        YQ_Fc: "0",
        //可选，指定UI语言，默认根据浏览器自动识别。
        YQ_Lang: "zh-CN",
        //必须，指定要查询的单号。
        // YQ_Num: "YT2018021266048349",
        YQ_Num: item.conveyNumber,
      });
    },
    reduction(val){
      this.$confirm('确认还原此采购需求吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const API = Baseurl + "purchaseDemandController/updatePurchaseDemandButtonStatus";
          const paramsData = { id:val.id ,roleId:this.str.rid};
          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data;
            if (code === 200) {
              this.$message({
                message:"还原成功",
                type:"success"
              })
              this.getTableList();
            }else{
              this.$message.error(data)
            }
          });
        })
      
    },
    checkReduction(val){
      this.$confirm('确认还原此采购需求审核状态吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const API = Baseurl + "logisticsController/purchaseDemandReturn";
          const paramsData = { id:val.id ,roleId:this.str.rid};
          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data;
            if (code === 200) {
              this.$message({
                message:"还原成功",
                type:"success"
              })
              this.getTableList();
            }else{
              this.$message.error(data)
            }
          });
        })
      
    },
    cancelIntercept(val){
      this.$confirm('确认对此采购需求取消拦截吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const API = Baseurl + "orderController/cancelOutIntercept";
          const paramsData = { id:val.id ,roleId:this.str.rid};
          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data;
            if (code === 200) {
              this.$message({
                message:"取消成功",
                type:"success"
              })
              this.getTableList();
            }else{
              this.$message.error(data)
            }
          });
        })
      
    }
  },
};
</script>

<style lang="scss" scoped>
.information {
  width: 98%;
  padding-bottom: 52px;
  overflow: hidden;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 500px;
  height: 500px;
}
</style>
